export const patientSteps = [
  {
    element: '#patientfilter',
    popover: {
      title: 'Filter & Search Patients ',
      showButtons: ['next', 'close'],
      description:
        '<div><li> Click the Filter button to open the filter panel, enter relevant fields (Provider, Last Name, Surgery Type, etc.), and Apply.</li></div>',
    },
  },
  {
    element: '#patientlist',
    popover: {
      title: 'View Patient List ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Each row shows Name, Provider, Surgery Date, plus Measurement/Exercise progress.</li><li> Hover over the Measurement Progress to see recorded values (pulse, temperature, etc.)</li><li>Check Exercise Progress pie charts for completion status.</li> </ul></div>',
    },
  },
  // {
  //     element: '#patientreportdownload',
  //     popover: {
  //     title: 'Download',
  //     showButtons:['previous','next', 'close'],
  //     description: '<div>  Download Patient Activity Report. .</div>'
  //     },

  // },
  //  {
  //     element: '#sendpatientmail',
  //     popover: {
  //     title: 'Message',
  //     showButtons:['previous','next', 'close'],
  //     description: '<div>  Send email to the patient.</div>'
  //     },

  // },
  // {
  //     element:'#resetpatientpassword',
  //     popover: {
  //     title: 'Un-Lock',
  //     showButtons:['previous','next', 'close'],
  //     description: '<div> Reset patient password.</div>'
  //     },
  // },
  {
    element: '#patientselfregister',
    popover: {
      title: 'PATIENT SELF REGISTER',
      showButtons: ['previous', 'next', 'close'],
      description: '<div><li> generates a link for patient signup.</li></div>',
    },
  },
  {
    element: '#patientadd',
    popover: {
      title: 'ADD PATIENT',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><li>  Opens a form to manually create a new patient profile.</li></div>',
    },
  },
]

export const patientInfoFormSteps = [
  {
    element: '#personaldetailsform',
    popover: {
      title: 'Enter Personal Details',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> Fill in First/Last Name, Date of Birth, Cell Phone, Email, Gender.</li><li>  Check Consent (if patient has consented) and Registered (if they’ve already signed up).</li> </ul></div>',
    },
  },

  {
    element: '#surgerydetailsform',
    popover: {
      title: 'Provide Surgery Details',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Select Surgery Type, choose the Provider, and enter the Date of Surgery.</li></ul></div>',
    },
  },
  {
    element: '#addressform',
    popover: {
      title: 'Shipping Address',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Under Ship Address, fill in address, city, state, ZIP, country.</li></ul></div>',
    },
  },
  {
    element: '#caregiverform',
    popover: {
      title: 'Caregiver Info ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>In Caregiver Details, list caregiver’s contact info and relationship (optional).</li></ul></div>',
    },
  },
  {
    element: '#nextstep',
    popover: {
      title: 'Proceed to Next Step ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Next to continue to the “Select Care Plan” screen.</li></ul></div>',
    },
  },
]
